export default {
  primary: '#90C657',
  secondary: '#069547',
  white: '#ffffff',
  oldwellBlue: '#4e96cc',
  darkBlue: '#13294B',
  gray: '#c6c6c6',
  red: 'rgb(215, 84, 82)',
}
